import { Component, OnInit, Inject, Input, ChangeDetectorRef } from '@angular/core';
// import { ManikEntityFEComponent, CookieManager, GridPrams } from 'app/basecomponent/ManikEntityFE';
// import { ManikEntityService } from 'app/service/ManikEntityService';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ManikEntityFE, GridPrams, CookieManager } from 'src/app/manik-library/ManikEntityFE';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';

@Component({
  selector: 'app-candid-photos',
  templateUrl: './candid-photos.component.html'
})
export class CandidPhotosComponent extends ManikEntityFE implements OnInit {
  candidForm: FormGroup;
  IPAddress: string = '';
  SessionData: any = {};
  submitted: boolean;
  MediaTagTypeList: any = [];
  SanitizedURL: any;
  YoutubeURL: any;
  AddEditMedia = false;
  BusinessImageID: any;
  MediaType: any;
  public DataTable = new MatTableDataSource<any>();
  public displayedColumns: string[] = ['MediaType', 'MediaURL', 'MediaHeader', 'BusinessImageID'];
  public columnsToDisplay: string[] = this.displayedColumns.slice();
  public IsEmptyGrid: boolean = true;
  PortalIdentifier: string = '';
  @Input() BusinessID: string = '';
  data: any = [];
  YtURL: any = [];
  Routes: boolean = false;
  Session: boolean = false;
  constructor(private formBuilder: FormBuilder,private cdRef: ChangeDetectorRef, private _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any, public sanitizer: DomSanitizer, private _router: Router) {
    super(document);
    this.candidForm = this.formBuilder.group({
      MediaType: ['', Validators.required],
      MediaTagType: ['', Validators.required],
      UploadDate: [this.defaultStartDate, Validators.required],
      MediaHeader: [''],
      DisplayOrder: [''],
      VideoURL: ['']
    })
  }

  get CandidForm() { return this.candidForm.controls }

  scrolltotop() {
    if (this.Session) {
      this.document.getElementById('iBreadCrumb1').scrollIntoView({ behaviour: 'smooth' });
    }
  }

  ngOnInit() {
    if (!sessionStorage.getItem('BusinessData')) {
      this.Routes = true;
      let route = this._router.url;
      let routes = route.split('/');
      this.PortalIdentifier = routes[3];
      this.populateControls();
      this.refreshDataGrid();
    }
    else {
      this.Session = true;
      this.SessionData = JSON.parse(sessionStorage.getItem('BusinessData'));
      this.BusinessID = this.SessionData.BUSINESSID;
      this.PortalIdentifier = this.SessionData.PortalIdentifier;
      this.populateControls();
      this.refreshDataGrid();
    }
    this.defaultStartDate.setDate(this.defaultStartDate.getDate());
    this._manikEntityService.manikGetMyIPAddress()
      .subscribe(data => {
        this.IPAddress = data.ip;
      });
  }

  RefreshFile() {
    this.ManikUploadedFile1 = null;
  }

  populateControls() {
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2('ULTRA.QUICK', 'ESTMEDIA.TAGS', 'QGLOBAL', this.PortalIdentifier)).subscribe(
        data => {
          this.MediaTagTypeList = data.ManikJSon[0].JSon0;
          // this.cdRef.detectChanges(); 
        });
  }

  refreshDataGrid() {
    this.manikLoadingResults = true;
    this.updateGridViewParams(GridPrams.gv_Param1, this.BusinessID);
    this.updateGridViewParams(GridPrams.gv_OrderByColumnName, "BusinessImageID");
    this.updateGridViewParams(GridPrams.gv_PageSize, this.PageSize);
    this.updateGridViewParams(GridPrams.gv_CurrentPage, this.CurrentPage);
    this.updateGridViewParams(GridPrams.gv_SortOrder, this.SortOrder)
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
     this.prepareGridViewHeaders2("BUSINESS.0.ESTABLISHMENT.MEDIA", "BIZ"))
      .subscribe(data => {
        if (data.ManikJSon[0].JSon0[0].BusinessImageID) {
          this.DataTable.data = data.ManikJSon[0].JSon0;
          this.data = data.ManikJSon[0].JSon0;
          for (let i = 0; i < this.data.length; i++) {
            this.data[i].YtURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.data[i].MediaURL);
          }
          this.IsEmptyGrid = false;
        }

        this.PageLength = data.ManikJSon[0].JSon1[0].TotRecords;
        this.manikLoadingResults = false;
        this.AddEditMedia = false;
      });
  }

  get f() {
    return this.candidForm.controls;
  }

  cancel() {
    this.AddEditMedia = !this.AddEditMedia;
  }

  VideoURLBlur(formControl: any) {
    if (!formControl.value) return;
    const headers = new HttpHeaders({
      'responseType': 'text/plain',
      'Authorization': 'Bearer ' + CookieManager.getCookie("manikAuthToken")
    });
    this._manikEntityService.manikEntityConnect2("clean/youtube?data=" + formControl.value, null, headers)
      .subscribe(data => {
        this.SanitizedURL = this.sanitizer.bypassSecurityTrustResourceUrl(data.value);
        this.YoutubeURL = data.value;
      });
  }

  AddMedia() {
    this.AddEditMedia = !this.AddEditMedia;
    this.BusinessImageID = null;
    this.candidForm.reset();
    this.RefreshFile();
    this.document.getElementById('CandidPhoto').setAttribute('src', this.NoImageURL);
    this.candidForm.controls['UploadDate'].setValue(new Date());
  }

  EditMedia(BusinessImageID) {
    this.document.getElementById('CandidPhoto').setAttribute('src', this.NoImageURL);
    this.RefreshFile();
    this.scrolltotop();
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, 
    this.prepareEditHeaders2(BusinessImageID.toString(), "BUSINESS.0.ESTABLISHMENT.MEDIA", "BIZ", this.PortalIdentifier))
      .subscribe(data => {
        this.candidForm.patchValue(data.ManikJSon[0].JSon0[0]);
        this.AddEditMedia = !this.AddEditMedia;
        this.BusinessImageID = data.ManikJSon[0].JSon0[0].BusinessImageID;
        this.MediaType = data.ManikJSon[0].JSon0[0].MediaType;
        if (this.candidForm.value.MediaType == 'I') {
          
          this.document.getElementById("CandidPhoto").setAttribute('src', data.ManikJSon[0].JSon0[0].MediaURL);
        }
        if (this.candidForm.value.MediaType == 'V') {

          this.document.getElementById("iCvideo").setAttribute('src', data.ManikJSon[0].JSon0[0].MediaURL);
          let elarray = this.document.getElementsByClassName('cvideo');
          for (let i = 0; i < elarray.length; i++) {
            elarray[i].setAttribute('src', data.ManikJSon[0].JSon0[0].MediaURL);
          }
        }
        if (this.candidForm.value.MediaType == 'Y') {
          this.SanitizedURL = this.sanitizer.bypassSecurityTrustResourceUrl(data.ManikJSon[0].JSon0[0].MediaURL);
          this.YoutubeURL = data.ManikJSon[0].JSon0[0].MediaURL;
          this.candidForm.controls['VideoURL'].setValue(this.YoutubeURL);
        }
      });
  }

  SendToDB() {
    let body = {};
    let actioncontext: string = '';
    this.submitted = true
    if (this.candidForm.invalid) {
      return;
    }
    body = this.candidForm.value;
    if (this.BusinessImageID) {
      body["BusinessImageID"] = this.BusinessImageID;
      actioncontext = 'E';
      if (this.MediaType != this.candidForm.value.MediaType) {
        if ((this.candidForm.controls.MediaType.value == 'I' || this.candidForm.controls.MediaType.value == 'V') && !this.ManikUploadedFile1) return;
        if ((this.candidForm.controls.MediaType.value == 'Y') && !this.YoutubeURL) return;
      }
    }
    else {
      actioncontext = 'A';
      if ((this.candidForm.controls.MediaType.value == 'I' || this.candidForm.controls.MediaType.value == 'V') && !this.ManikUploadedFile1) return;
      if ((this.candidForm.controls.MediaType.value == 'Y') && !this.YoutubeURL) return;
    }

    body['BusinessID'] = this.BusinessID;
    body['UploaderAgentID'] = '0';
    body['IPAddress'] = this.IPAddress ? this.IPAddress : '';
    body['MediaURL'] = this.ManikUploadedFile1 ? this._manikEntityService.uploadURL + this.manikGetFileExtFromName(this.ManikUploadedFileName1[0]) : '';
    if (this.candidForm.controls.MediaType.value == 'Y') {
      body['MediaURL'] = this.YoutubeURL;
    }
    let FormSubmittedDataTwo = JSON.stringify({ 'items': [body] });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", FormSubmittedDataTwo, this.prepareManageHeaders2(actioncontext, "BUSINESS.0.ESTABLISHMENT.MEDIA", "BIZ", this.PortalIdentifier))
      .subscribe(data => {
        let path = data.ManikJSon[0].JSon0[0].SavePath;
        let filename = data.ManikJSon[0].JSon0[0].FileName1;
        this.submitted = false;
        if (this.ManikUploadedFile1 && this.candidForm.controls['MediaType'].value == 'I') {
          this._manikEntityService.manikImageUpload(this.ManikUploadedFile1,
            this.prepareImageUploadHeader(path, filename + '.' + this.manikGetFileExtFromName(this.ManikUploadedFileName1[0]), "", "", "user_data"))
            .subscribe(success => {
              this.document.getElementById("candid-photo-upload").setAttribute("value", null);
            });
        }
        if (this.ManikUploadedFile1 && this.candidForm.controls['MediaType'].value == 'V') {
          this._manikEntityService.manikDocUpload(this.ManikUploadedFile1,
            this.prepareDocUploadHeader(path, filename + '.' + this.manikGetFileExtFromName(this.ManikUploadedFileName1[0])))
            .subscribe(success => {
              this.document.getElementById("candid-video-upload").setAttribute("value", null);
            });
        }
        this.submitted = false;
        this.refreshDataGrid();
      });
  }



  DeleteMedia(BusinessImageID) {
    let body: any = {};
    body['BusinessImageID'] = BusinessImageID;
    let FormSubmittedDataTwo = JSON.stringify({ 'items': [body] });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", FormSubmittedDataTwo, this.prepareManageHeaders2("D", "BUSINESS.0.ESTABLISHMENT.MEDIA", "BIZ", this.PortalIdentifier))
      .subscribe(data => {
        this.refreshDataGrid();
      });
  }

}
